import {yupResolver} from "@hookform/resolvers/yup";
import * as Yup from "yup";

export const DataDogShape = {
  api_key: Yup.string().label("API Key").min(32).max(32).required(),
  app_key: Yup.string().label("App Key").min(40).max(40).required(),
  region: Yup.string().label("API Region").optional(),
  prepend_check_tags: Yup.boolean().label('Prepend "uptime-tag:" to check tags').optional(),
};

export interface DataDogInput {
  api_key: string;
  app_key: string;
  region?: string;
  prepend_check_tags?: boolean;
}

export const DataDogDefaults = {
  region: "US",
  prepend_check_tags: true,
};

yupResolver<DataDogInput>(Yup.object().shape(DataDogShape));
